import { Alert } from '@/global/components/Alert'
import { cn } from '@/lib/utils'
import { SmartphoneIcon } from 'lucide-react'

type AvisoRotacionarTelaProps = {
    mensagem?: string
    className?: string
}

/**
 * Aviso exibido quando a tela é estreita demais para um formulário largo.
 * Mostra um celular animado girando para a horizontal, sugerindo ao usuário
 * rotacionar o dispositivo ou usar uma tela maior.
 *
 * Controle a visibilidade pelo container (ex.: `<div className="xl:hidden">`).
 */
export default function AvisoRotacionarTela({
    mensagem = 'Esta tela é estreita para o formulário. Gire o dispositivo para a horizontal ou use uma tela maior para visualizar melhor.',
    className,
}: AvisoRotacionarTelaProps) {
    return (
        <Alert
            severity="warning"
            icon={false}
            className={cn('mb-4', className)}
        >
            <div className="flex items-center gap-3">
                <SmartphoneIcon className="animate-rotate-phone shrink-0" />
                <span>{mensagem}</span>
            </div>
        </Alert>
    )
}
